<template>
  <div class="OAJump">
    <div @click="jumpTo" class="linkClass">{{scope.row[textKey]}}</div>
  </div>
</template>

<script>
import { jump } from "@/common/jump";
export default {
  name: "OAJump",
  props: {
    url: {
      default: null
    },
    paramKey: {
      default: null
    },
    textKey: {
      default: null
    },
    scope: {
      default: null
    },
    query: {
      default: null
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    jumpTo() {
      jump({
        url: this.url,
        query: { [this.paramKey]: this.scope.row.id, ...this.query }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.linkClass {
  color: #409eff;
  cursor: pointer;
}
</style>





// WEBPACK FOOTER //
// src/components/OAJump/OAJump.vue